var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchShat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 31.0614L27.134 25.4431C28.5436 23.8222 29.2466 21.7433 29.0966 19.6387C28.9466 17.5341 27.9552 15.5659 26.3287 14.1435C24.7022 12.7212 22.5657 11.9542 20.3638 12.0021C18.1619 12.05 16.064 12.9092 14.5066 14.4008C12.9493 15.8924 12.0522 17.9017 12.0022 20.0107C11.9522 22.1196 12.753 24.1659 14.238 25.7237C15.7231 27.2815 17.778 28.2311 19.9754 28.3747C22.1728 28.5184 24.3434 27.8451 26.0357 26.495L31.9017 32.1133L33 31.0614ZM13.5813 20.2101C13.5813 18.8858 13.9913 17.5913 14.7594 16.4902C15.5276 15.3891 16.6194 14.531 17.8968 14.0242C19.1742 13.5174 20.5798 13.3848 21.9358 13.6432C23.2919 13.9015 24.5375 14.5392 25.5152 15.4756C26.4929 16.412 27.1587 17.605 27.4284 18.9038C27.6982 20.2027 27.5597 21.5489 27.0306 22.7724C26.5015 23.9958 25.6055 25.0415 24.4559 25.7773C23.3062 26.513 21.9547 26.9057 20.572 26.9057C18.7186 26.9037 16.9417 26.1976 15.6311 24.9424C14.3205 23.6872 13.5833 21.9853 13.5813 20.2101V20.2101Z",
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchShat);
export default __webpack_public_path__ + "static/media/IconSearchShat.2665da5a.svg";
export { ForwardRef as ReactComponent };